import React from 'react';
import CustomNav from '../Navbar/CustomNav';
import SubNav from '../Navbar/SubNav';
import '../css/App.css';
import { useLocation } from 'react-router-dom';

function Header() {
  const location = useLocation();

  const backgroundColor = location.pathname === '/login' || location.pathname === '/register' ? 'rgba(255, 255, 255, 1)' : 'rgba(255, 255, 255, 1)'; // Transparent black (0 opacity)
  const blurEffect = location.pathname === '/login' || location.pathname === '/register' ? 'blur(40px)' : '';
  const headerStyle = {
    "backgroundColor": backgroundColor, 
    "backdrop-filter": blurEffect,
  };

  console.log(headerStyle);

  return (
    <div style={headerStyle}>
      <CustomNav />
    </div>
  );
}

export default Header;
